export const teluguFlashcards = {
  categories: [
    {
      te: "నమస్కారం",
      rm: "Namaskaram",
      en: "Hello / Greetings",
    },
    {
      te: "ఎలా ఉన్నారు?",
      rm: "Elaa unnaaru?",
      en: "How are you? (formal)",
    },
    {
      te: "ఏమిటి విశేషాలు?",
      rm: "Emiti visheshaalu?",
      en: "What's up? / What's new?",
    },
    {
      te: "నేను బాగున్నాను",
      rm: "Nenu baagunnaanu",
      en: "I am fine",
    },
    {
      te: "ధన్యవాదాలు",
      rm: "Dhanyavaadaalu",
      en: "Thank you",
    },
    {
      te: "చాలా ధన్యవాదాలు",
      rm: "Chalaa dhanyavaadaalu",
      en: "Thank you very much",
    },
    {
      te: "పర్వాలేదు",
      rm: "Parvaaledu",
      en: "You're welcome / It's okay / Never mind",
    },
    {
      te: "క్షమించండి",
      rm: "Kshaminchandi",
      en: "Excuse me / Sorry",
    },
    {
      te: "దయచేసి",
      rm: "Dayachesi",
      en: "Please",
    },
    {
      te: "అవును",
      rm: "Avunu",
      en: "Yes",
    },
    {
      te: "లేదు",
      rm: "Ledu",
      en: "No",
    },
    {
      te: "సరే",
      rm: "Sare",
      en: "Okay / Alright",
    },
    {
      te: "నాకు అర్థం కాలేదు",
      rm: "Naaku artham kaaledu",
      en: "I don't understand",
    },
    {
      te: "మీకు ఇంగ్లీష్ తెలుసా?",
      rm: "Meeku English telusaa?",
      en: "Do you know English?",
    },
    {
      te: "ఇది ఏమిటి?",
      rm: "Idi emiti?",
      en: "What is this?",
    },
    {
      te: "ఇది ఎంత?",
      rm: "Idi enta?",
      en: "How much is this?",
    },
    {
      te: "ఎక్కడ ఉంది?",
      rm: "Ekkada undi?",
      en: "Where is...?",
    },
    {
      te: "టాయిలెట్ ఎక్కడ ఉంది?",
      rm: "Toilet ekkada undi?",
      en: "Where is the toilet?",
    },
    {
      te: "రైల్వే స్టేషన్ ఎక్కడ ఉంది?",
      rm: "Railway station ekkada undi?",
      en: "Where is the railway station?",
    },
    {
      te: "విమానాశ్రయం ఎక్కడ ఉంది?",
      rm: "Vimaanaashrayam ekkada undi?",
      en: "Where is the airport?",
    },
    {
      te: "ఆసుపత్రి ఎక్కడ ఉంది?",
      rm: "Aasupatri ekkada undi?",
      en: "Where is the hospital?",
    },
    {
      te: "సహాయం చేయండి!",
      rm: "Sahaayam cheyandi!",
      en: "Help!",
    },
    {
      te: "పోలీసులు!",
      rm: "Policeulu!",
      en: "Police!",
    },
    {
      te: "నాకు సహాయం కావాలి",
      rm: "Naaku sahaayam kaavaali",
      en: "I need help",
    },
    {
      te: "నేను తప్పిపోయాను",
      rm: "Nenu tappipoyaanu",
      en: "I am lost",
    },
    {
      te: "మీరు నాకు సహాయం చేయగలరా?",
      rm: "Meeru naaku sahaayam cheyagalaraa?",
      en: "Can you help me?",
    },
    {
      te: "నెమ్మదిగా మాట్లాడండి",
      rm: "Nemmadigaa maatlaadandi",
      en: "Speak slowly",
    },
    {
      te: "మళ్ళీ చెప్పండి",
      rm: "Malli cheppandi",
      en: "Say it again",
    },
    {
      te: "నాకు ఆరోగ్యం బాగాలేదు",
      rm: "Naaku aarogyam baagoledu",
      en: "I am not feeling well / I am sick",
    },
    {
      te: "నాకు డాక్టర్ కావాలి",
      rm: "Naaku doctor kaavaali",
      en: "I need a doctor",
    },
    {
      te: "ఇది చాలా ఖరీదైనది",
      rm: "Idi chaalaa khareedainadi",
      en: "This is too expensive",
    },
    {
      te: "కొంచెం తగ్గించగలరా?",
      rm: "Konchem tagginchagalaraa?",
      en: "Can you lower the price?",
    },
    {
      te: "నాకు ఇది కావాలి",
      rm: "Naaku idi kaavaali",
      en: "I want this",
    },
    {
      te: "నాకు ఇది వద్దు",
      rm: "Naaku idi vaddu",
      en: "I don't want this",
    },
    {
      te: "నా పేరు ...",
      rm: "Naa peru ...",
      en: "My name is...",
    },
    {
      te: "మీరు ఎలా ఉన్నారు?",
      rm: "Meeru elaa unnaaru?",
      en: "How are you? (formal)",
    },
    {
      te: "ఏమి చేస్తున్నారు?",
      rm: "Emi chestunnaaru?",
      en: "What are you doing? (formal)",
    },
    {
      te: "నేను బాగున్నాను, ధన్యవాదాలు",
      rm: "Nenu baagunnaanu, dhanyavaadaalu",
      en: "I am fine, thank you",
    },
    {
      te: "మంచిది",
      rm: "Manchidi",
      en: "Good",
    },
    {
      te: "చాలా మంచిది",
      rm: "Chalaa manchidi",
      en: "Very good",
    },
    {
      te: "చెడ్డది",
      rm: "Cheddadi",
      en: "Bad",
    },
    {
      te: "శుభోదయం",
      rm: "Shubodayam",
      en: "Good morning",
    },
    {
      te: "శుభ మధ్యాహ్నం",
      rm: "Shubha madhyaahnam",
      en: "Good afternoon",
    },
    {
      te: "శుభ సాయంత్రం",
      rm: "Shubha saayantram",
      en: "Good evening",
    },
    {
      te: "శుభ రాత్రి",
      rm: "Shubha raatri",
      en: "Good night",
    },
    {
      te: "వెళ్లి రండి",
      rm: "Velli randi",
      en: "Goodbye",
    },
    {
      te: "మళ్ళీ కలుద్దాం",
      rm: "Malli kaluddaam",
      en: "See you again",
    },
    {
      te: "కుడి వైపుకు",
      rm: "Kudi vaipuku",
      en: "To the right",
    },
    {
      te: "ఎడమ వైపుకు",
      rm: "Edama vaipuku",
      en: "To the left",
    },
    {
      te: "నేరుగా",
      rm: "Nerugaa",
      en: "Straight ahead",
    },
    {
      te: "పైకి",
      rm: "Paiki",
      en: "Up",
    },
    {
      te: "క్రిందికి",
      rm: "Krimdiki",
      en: "Down",
    },
    {
      te: "దగ్గరలో",
      rm: "Daggaralo",
      en: "Near",
    },
    {
      te: "దూరంగా",
      rm: "Dooramgaa",
      en: "Far",
    },
    {
      te: "ఈరోజు",
      rm: "Eeroju",
      en: "Today",
    },
    {
      te: "రేపు",
      rm: "Repu",
      en: "Tomorrow",
    },
    {
      te: "నిన్న",
      rm: "Ninna",
      en: "Yesterday",
    },
    {
      te: "ఇప్పుడు",
      rm: "Ippudu",
      en: "Now",
    },
    {
      te: "తరువాత",
      rm: "Tarvaata",
      en: "Later",
    },
    {
      te: "ఉదయం",
      rm: "Udayam",
      en: "Morning",
    },
    {
      te: "మధ్యాహ్నం",
      rm: "Madhyaahnam",
      en: "Afternoon",
    },
    {
      te: "సాయంత్రం",
      rm: "Saayantram",
      en: "Evening",
    },
    {
      te: "రాత్రి",
      rm: "Ratri",
      en: "Night",
    },
    {
      te: "నీరు",
      rm: "Neeru",
      en: "Water",
    },
    {
      te: "ఆహారం",
      rm: "Aahaaram",
      en: "Food",
    },
    {
      te: "టీ",
      rm: "Tee",
      en: "Tea",
    },
    {
      te: "కాఫీ",
      rm: "Kaaphee",
      en: "Coffee",
    },
    {
      te: "బీరు",
      rm: "Beeru",
      en: "Beer",
    },
    {
      te: "మద్యం",
      rm: "Madyam",
      en: "Alcohol",
    },
    {
      te: "శాకాహారి",
      rm: "Saakaahaari",
      en: "Vegetarian",
    },
    {
      te: "మాంసాహారి",
      rm: "Maamsaahaari",
      en: "Non-vegetarian",
    },
    {
      te: "ఇది శాకాహారమా?",
      rm: "Idi saakaahaaramaa?",
      en: "Is this vegetarian?",
    },
    {
      te: "నాకు ఆకలిగా ఉంది",
      rm: "Naaku aakaligaa undi",
      en: "I am hungry",
    },
    {
      te: "నాకు దాహంగా ఉంది",
      rm: "Naaku daahamgaa undi",
      en: "I am thirsty",
    },
    {
      te: "ఎంత సమయం పడుతుంది?",
      rm: "Enta samayam padutundi?",
      en: "How much time will it take?",
    },
    {
      te: "పాస్పోర్ట్",
      rm: "Passport",
      en: "Passport",
    },
    {
      te: "వీసా",
      rm: "Visa",
      en: "Visa",
    },
    {
      te: "టికెట్",
      rm: "Ticket",
      en: "Ticket",
    },
    {
      te: "హోటల్",
      rm: "Hotel",
      en: "Hotel",
    },
    {
      te: "గది",
      rm: "Gadi",
      en: "Room",
    },
    {
      te: "నేను ఒక గది బుక్ చేయాలనుకుంటున్నాను",
      rm: "Nenu oka gadi book cheyaalanukuntunnaanu",
      en: "I want to book a room",
    },
    {
      te: "ఇది చాలా బాగుంది",
      rm: "Idi chaalaa baagundi",
      en: "This is very good",
    },
    {
      te: "ఇది చాలా చెడ్డది",
      rm: "Idi chaalaa cheddadi",
      en: "This is very bad",
    },
    {
      te: "సమస్య లేదు",
      rm: "Samasya ledu",
      en: "No problem",
    },
    {
      te: "శుభాకాంక్షలు",
      rm: "Shubhaakaankshalu",
      en: "Best wishes / Congratulations",
    },
    {
      te: "ఆనందించండి",
      rm: "Aanandinchandi",
      en: "Have fun",
    },
    {
      te: "తినండి",
      rm: "Tinandi",
      en: "Please eat (formal)",
    },
    {
      te: "త్వరగా రండి",
      rm: "Tvaragaa randi",
      en: "Come quickly",
    },
    {
      te: "ఇక్కడకు రండి",
      rm: "Ikkadaku randi",
      en: "Come here",
    },
    {
      te: "కూర్చోండి",
      rm: "Koorchondi",
      en: "Sit down",
    },
    {
      te: "చూడండి",
      rm: "Choodandi",
      en: "Look",
    },
  ],
};
